import { SetupPayment } from './setup-payment';
import { StripeContextProvider } from '../../../../context/stripe-context';
import { CustomerContextProvider } from '../../../../context/customer-context';

export default function StripeSetupInit({
  color,
  enableCancel,
  onCancel,
  onSubmit,
  type = 'card',
}: {
  color: string;
  enableCancel?: boolean;
  onCancel?: () => void;
  onSubmit: () => void;
  type?: 'bankAccount' | 'card';
}) {
  return (
    <StripeContextProvider>
      <CustomerContextProvider>
        <SetupPayment color={color} onCancel={onCancel} enableCancel={enableCancel} onSubmit={onSubmit} type={type} />
      </CustomerContextProvider>
    </StripeContextProvider>
  );
}
